import { IEnvCellRoute } from '_/types/envCellRoutes/envCellRoutes.types';
import { IExtractionCell, IExtractionCellForm } from '_/types/extractionCells/extractionCells.types';
import zeusSdk from '_/utils/SDKs';

export const fetchExtractionCells = async (): Promise<IExtractionCell[]> => {
  try {
    const extractionCells = await zeusSdk.extractionCells.listAll();
    return extractionCells || [];
  } catch (error) {
    console.error('Error fetching extraction cells', error);
    throw error;
  }
};

export const fetchExtractionCellById = async (id: string): Promise<IExtractionCell> => {
  try {
    const extractionCell = await zeusSdk.extractionCells.get(id);
    return extractionCell;
  } catch (error) {
    console.error('Error fetching extraction cell by id', error);
    throw error;
  }
};

export const fetchEnvCellRoutesForExtractionCell = async (extractionCellId: string): Promise<IEnvCellRoute[]> => {
  try {
    const { items } = await zeusSdk.extractionCells.getChildren(extractionCellId, 'envcellroutes', {
      include: 'editor',
    });
    return items || [];
  } catch (error) {
    console.error('Error fetching env cell routes for extraction cell', error);
    throw error;
  }
};

export const createExtractionCell = async (data: Partial<IExtractionCellForm>): Promise<IExtractionCell> => {
  try {
    const result = await zeusSdk.extractionCells.create(data);
    return result;
  } catch (error) {
    console.error('Error creating extraction cell', error);
    throw error;
  }
};

export const updateExtractionCell = async (id: string, data: Partial<IExtractionCellForm>): Promise<IExtractionCell> => {
  try {
    const result = await zeusSdk.extractionCells.patch(id, data);
    return result;
  } catch (error) {
    console.error('Error updating extraction cell', error);
    throw error;
  }
};
